import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { useActivityTracking } from '@/components/ActivityTrackingProvider';

interface TrackableButtonProps extends ButtonProps {
  trackingData?: {
    feature?: string;
    action?: string;
    category?: string;
    context?: Record<string, any>;
  };
  children: React.ReactNode;
}

export const TrackableButton: React.FC<TrackableButtonProps> = ({
  trackingData,
  onClick,
  children,
  ...buttonProps
}) => {
  const { trackCustomActivity } = useActivityTracking();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Track the button click
    if (trackingData) {
      const { feature, action, category, context } = trackingData;
      trackCustomActivity(`button_click_${action || 'unknown'}`, {
        feature: feature || 'unknown',
        category: category || 'button',
        buttonText: typeof children === 'string' ? children : 'complex_content',
        ...context
      });
    }

    // Call the original onClick handler
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Button 
      {...buttonProps} 
      onClick={handleClick}
      data-track={trackingData?.action || 'button'}
    >
      {children}
    </Button>
  );
}; 